import styled from 'styled-components'

export const Container = styled.span`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: baseline;
  white-space: normal;
  min-width: 0;
`

export const Description = styled.span`
  word-wrap: break-word;
  overflow-wrap: break-word;
  min-width: 0;
`
